import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { NativeButton, NativeCard, NativeCardContent } from '../components/NativeComponents';
import { ShieldX, ArrowLeft, Home, LogOut } from 'lucide-react';

export default function UnauthorizedPage({ message }) {
  const navigate = useNavigate();
  const { logout, user } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      backgroundColor: '#f8fafc',
      padding: '20px'
    }}>
      <NativeCard style={{ maxWidth: '450px', width: '100%', textAlign: 'center' }}>
        <NativeCardContent style={{ padding: '48px 32px' }}>
          <div style={{ 
            width: '80px', 
            height: '80px', 
            borderRadius: '50%', 
            backgroundColor: '#fee2e2',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px'
          }}>
            <ShieldX style={{ width: '40px', height: '40px', color: '#dc2626' }} />
          </div>
          
          <h1 style={{ 
            fontSize: '24px', 
            fontWeight: '700', 
            color: '#1e293b',
            marginBottom: '12px'
          }}>
            Yetkiniz Yok
          </h1>
          
          <p style={{ 
            fontSize: '15px', 
            color: '#64748b',
            marginBottom: '32px',
            lineHeight: '1.6'
          }}>
            {message || 'Bu sayfaya erişim yetkiniz bulunmamaktadır. Lütfen sistem yöneticinizle iletişime geçin.'}
          </p>

          {user && (
            <div style={{ 
              padding: '12px 16px', 
              backgroundColor: '#f1f5f9', 
              borderRadius: '8px',
              marginBottom: '24px',
              fontSize: '14px',
              color: '#475569'
            }}>
              <strong>{user.full_name || user.email}</strong>
              <br />
              <span style={{ fontSize: '12px', color: '#94a3b8' }}>
                Rol: {user.role === 'super_admin' ? 'Süper Admin' : 
                      user.role === 'admin' ? 'Admin' :
                      user.role === 'site_manager' ? 'Site Yöneticisi' : 'Kullanıcı'}
              </span>
            </div>
          )}
          
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <NativeButton variant="outline" onClick={() => navigate(-1)}>
              <ArrowLeft style={{ width: '16px', height: '16px' }} />
              Geri Dön
            </NativeButton>
            
            <NativeButton onClick={() => navigate('/')}>
              <Home style={{ width: '16px', height: '16px' }} />
              Ana Sayfa
            </NativeButton>
            
            <NativeButton variant="ghost" onClick={handleLogout} style={{ color: '#dc2626' }}>
              <LogOut style={{ width: '16px', height: '16px' }} />
              Çıkış
            </NativeButton>
          </div>
        </NativeCardContent>
      </NativeCard>
    </div>
  );
}
